import React from 'react';
import { ArrowUpDown } from 'lucide-react';

/**
 * MobileSortControl — mobile equivalent of clickable desktop column headers.
 * Binds to the existing useTableStandard sort state ({ key, dir }) so sorting
 * stays synchronized with the desktop table. No fields are added or removed.
 */
export const MobileSortControl = ({ sort, setSort, options = [], testid = 'mobile-sort' }) => {
  const value = sort && sort.key ? `${sort.key}:${sort.dir}` : '';
  const onChange = (e) => {
    const v = e.target.value;
    if (!v) { setSort({ key: null, dir: 0 }); return; }
    const [key, dir] = v.split(':');
    setSort({ key, dir: Number(dir) });
  };
  return (
    <label className="inline-flex min-h-[44px] w-full items-center gap-2 rounded-lg border border-slate-200 bg-white px-3" data-testid={testid}>
      <ArrowUpDown size={15} className="shrink-0 text-slate-400" />
      <span className="shrink-0 text-xs font-semibold text-slate-500">Sort by</span>
      <select
        value={value}
        onChange={onChange}
        className="min-w-0 flex-1 bg-transparent py-2 text-sm text-[#0E2A47] outline-none"
        data-testid={`${testid}-select`}
      >
        <option value="">Default</option>
        {options.map((o) => (
          <React.Fragment key={o.key}>
            <option value={`${o.key}:1`}>{o.label} (A→Z)</option>
            <option value={`${o.key}:-1`}>{o.label} (Z→A)</option>
          </React.Fragment>
        ))}
      </select>
    </label>
  );
};

export default MobileSortControl;
